import Container from './Container'
import FeaturesTable from './FeaturesTable'

const FirstSharedFaqs = [
  {
    question: 'What is Writefull?',
    answer: (
      <>
        At Writefull, we use AI to help you write and proofread your academic texts. Our tools
        revise your language, write abstracts, paraphrase texts, make your sentences academic, and
        more. You can download{' '}
        <a
          href='https://www.writefull.com/writefull-for-word'
          target='_blank'
          className='underline'
          rel='noreferrer'
        >
          Writefull for Word
        </a>{' '}
        and{' '}
        <a
          href='https://www.writefull.com/writefull-for-overleaf'
          target='_blank'
          className='underline'
          rel='noreferrer'
        >
          Writefull for Overleaf
        </a>{' '}
        from our website.
      </>
    ),
  },
]

const LastSharedFaqs = [
  {
    question: 'Do you have more tools to help me write?',
    answer: (
      <>
        Definitely! Download{' '}
        <a
          href='https://www.writefull.com/writefull-for-word'
          className='underline'
          target='_blank'
          rel='noreferrer'
        >
          Writefull for Word
        </a>{' '}
        or{' '}
        <a
          href='https://www.writefull.com/writefull-for-overleaf'
          className='underline'
          target='_blank'
          rel='noreferrer'
        >
          Writefull for Overleaf
        </a>{' '}
        to get a set of AI writing widgets, along with Writefull&rsquo;s automated language edits.
        Several independent analyses by publishers and copy editors have shown that Writefull
        outperforms all other AI proofreading tools - so why not give it a try? (It&rsquo;s free,
        too.)
      </>
    ),
  },
  {
    question: 'Is your question not here?',
    answer: (
      <>
        If you have a question about Writefull that is not answered here, please{' '}
        <a
          href='https://my.writefull.com/contact'
          className='underline'
          target='_blank'
          rel='noreferrer'
        >
          contact us
        </a>
        .
      </>
    ),
  },
]

export interface FAQsProps {
  faqs: {
    question: string
    answer: string
  }[]
  tableFeatures: {
    feature: string
    description: string
  }[]
  widgetName: string
}

export default function FAQs({ faqs, tableFeatures, widgetName }: FAQsProps) {
  return (
    <Container className='mt-8 lg:mt-12 py-8 lg:py-16 border-t border-gray-200 dark:border-slate-600 theme-transition'>
      <h2 className='text-2xl font-medium tracking-tight'>
        Frequently asked questions about the {widgetName}
      </h2>
      <div className='mt-12'>
        <div className='mb-12'>
          <p className='mb-2 text-lg font-medium leading-6'>{`What are the ${widgetName}'s key features?`}</p>
          <FeaturesTable tableFeatures={tableFeatures} />
        </div>
        <dl className='space-y-12'>
          {[...FirstSharedFaqs, ...faqs, ...LastSharedFaqs].map((faq) => (
            <div key={faq.question}>
              <dt className='text-lg font-medium leading-6'>{faq.question}</dt>
              <dd className='mt-2 text-base text-gray-500 dark:text-gray-400'>{faq.answer}</dd>
            </div>
          ))}
        </dl>
      </div>
    </Container>
  )
}
